export class BookmarkService {
  constructor() {
	this.STORAGE_KEY = 'govsky_bookmarks';
  }

  getBookmarks() {
	try {
	  const bookmarks = localStorage.getItem(this.STORAGE_KEY);
	  return bookmarks ? JSON.parse(bookmarks) : [];
	} catch (error) {
	  // Silent fail - return empty array on bookmark retrieval error
	  return [];
	}
  }

  addBookmark(post) {
    try {
      const bookmarks = this.getBookmarks();
      const postCid = post.post.cid;
      
      if (!bookmarks.some(b => b.post.post.cid === postCid)) {
        bookmarks.unshift({
          post,
          savedAt: new Date().toISOString()
        });
        localStorage.setItem(this.STORAGE_KEY, JSON.stringify(bookmarks));
      }
      return true;
    } catch (error) {
      return false;
    }
  }

  removeBookmark(postCid) {
    try {
      const bookmarks = this.getBookmarks();
      const filtered = bookmarks.filter(b => b.post.post.cid !== postCid);
      
      if (bookmarks.length !== filtered.length) {
        localStorage.setItem(this.STORAGE_KEY, JSON.stringify(filtered));
        return true;
      }
      return false;
    } catch (error) {
      return false;
    }
  }

  isBookmarked(postCid) {
	const bookmarks = this.getBookmarks();
	return bookmarks.some(b => b.post.post.cid === postCid);
  }
}